<template>
    <router-link class="start-dh mt-3" :to="to">
        <span class="sd-ic">
            <v-icon color="#FFFFFF" size="24">mdi-rocket-launch-outline</v-icon>
        </span>
        <div class="sd-body">
            <span v-if="currentTariff?.isTrial" class="sd-badge">Тестовый период · осталось {{ trialDaysLeft }} дней</span>
            <div class="sd-t">Старт в DH</div>
            <div class="sd-d">Ощути эффективность системы за 7 дней, подключив ХИТы Data Heroes.</div>
            <div class="sd-steps">
                <span
                    v-if="scenariosLoading"
                    class="sd-steps-loader"
                    aria-hidden="true"
                ></span>
                <template v-else>
                    <span
                        v-for="index in scenarioTotal"
                        :key="`starter-pack-dot-${index}`"
                        class="sd-dot"
                        :class="{ on: index <= scenarioActive }"
                    ></span>
                </template>
                <span class="sd-steps-l">сценариев Быстрого старта</span>
            </div>
        </div>
        <div class="sd-right">
            <span class="sd-cta">
                Начать
                <v-icon color="currentColor" size="16">mdi-arrow-right</v-icon>
            </span>
        </div>
    </router-link>
</template>

<script>
import { computed } from 'vue'
import { useBillingStore } from '@root/src/store/stores/billing'
import { useProject } from '@root/src/hooks/useProject'

export default {
    name: 'StarterPackPromoCard',
    setup() {
        const { project } = useProject()
        const billingStore = useBillingStore()
        const currentTariff = computed(() => billingStore.getCurrentTariff(project.value.id))
        return { currentTariff }
    },
    props: {
        to: {
            type: String,
            required: true,
        },
        trialDaysLeft: {
            type: Number,
            default: 0,
        },
        scenarioTotal: {
            type: Number,
            default: 0,
        },
        scenarioActive: {
            type: Number,
            default: 0,
        },
        scenariosLoading: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="sass" scoped>
.start-dh
    position: relative
    display: flex
    align-items: center
    gap: 20px
    width: 100%
    padding: 18px 24px
    margin: 16px 0 6px
    overflow: hidden
    color: #fff
    text-decoration: none
    cursor: pointer
    background: linear-gradient(115deg, #525AD5 0%, #5E54CE 55%, #6E4FC4 100%)
    border: none
    border-radius: 16px
    box-shadow: 0 8px 24px rgba(82, 90, 213, .26)
    transition: transform .15s ease, box-shadow .15s ease
    box-sizing: border-box

    &::before
        content: ''
        position: absolute
        top: -110px
        right: 120px
        width: 230px
        height: 230px
        background: radial-gradient(circle, rgba(255, 255, 255, .14), transparent 70%)
        border-radius: 50%
        pointer-events: none

    > *
        position: relative
        z-index: 1

    &:hover
        transform: translateY(-2px)
        box-shadow: 0 14px 32px rgba(82, 90, 213, .34)

.sd-ic
    display: inline-flex
    align-items: center
    justify-content: center
    width: 56px
    height: 56px
    background: rgba(255, 255, 255, .16)
    border: 1px solid rgba(255, 255, 255, .24)
    border-radius: 15px
    flex-shrink: 0

.sd-body
    min-width: 0
    flex: 1

.sd-badge
    display: inline-flex
    align-items: center
    gap: 6px
    margin-bottom: 6px
    padding: 3px 9px
    color: #fff
    font-size: 9.5px
    font-weight: 800
    letter-spacing: .05em
    text-transform: uppercase
    background: rgba(255, 255, 255, .16)
    border: 1px solid rgba(255, 255, 255, .22)
    border-radius: 7px
    max-width: 100%
    box-sizing: border-box

    &::before
        content: ''
        width: 5px
        height: 5px
        flex-shrink: 0
        background: #D4EC38
        border-radius: 50%
        box-shadow: 0 0 0 3px rgba(212, 236, 56, .25)

.sd-t
    font-size: 18px
    font-weight: 900
    letter-spacing: -.025em
    color: #fff
    line-height: 1.2

.sd-d
    max-width: 470px
    margin-top: 3px
    color: rgba(255, 255, 255, .74)
    font-size: 12.5px
    line-height: 1.45

.sd-steps
    display: flex
    align-items: center
    flex-wrap: wrap
    gap: 6px
    margin-top: 11px

.sd-steps-loader
    flex: 1 1 160px
    min-width: 120px
    max-width: 360px
    height: 5px
    border-radius: 3px
    background: rgba(255, 255, 255, .22)
    overflow: hidden
    position: relative

    &::after
        content: ''
        position: absolute
        inset: 0
        background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, .55) 50%, transparent 100%)
        transform: translateX(-100%)
        animation: sd-steps-shimmer 1.15s ease-in-out infinite

@keyframes sd-steps-shimmer
    100%
        transform: translateX(100%)

.sd-dot
    width: 24px
    height: 5px
    flex-shrink: 0
    background: rgba(255, 255, 255, .26)
    border-radius: 3px
    transition: background .2s ease

    &.on
        background: #fff

.sd-steps-l
    color: rgba(255, 255, 255, .6)
    font-size: 11px
    line-height: 1.3
    white-space: nowrap

.sd-right
    flex-shrink: 0

.sd-cta
    display: inline-flex
    align-items: center
    justify-content: center
    gap: 8px
    padding: 12px 22px
    color: #525AD5
    font-size: 13.5px
    font-weight: 800
    white-space: nowrap
    background: #fff
    border-radius: 11px
    box-shadow: 0 4px 12px rgba(26, 26, 46, .12)
    transition: transform .15s ease
    box-sizing: border-box

    .v-icon
        color: inherit !important

.start-dh:hover .sd-cta
    transform: translateX(2px)

@media (max-width: 980px)
    .start-dh
        gap: 16px
        padding: 16px 18px

    .sd-d
        max-width: none

    .sd-dot
        width: 18px

@media (max-width: 720px)
    .start-dh
        display: grid
        grid-template-columns: auto 1fr
        grid-template-areas: "icon body" "cta cta"
        align-items: start
        gap: 14px 14px
        padding: 16px
        border-radius: 14px

        &::before
            top: -80px
            right: -40px
            width: 160px
            height: 160px

        &:hover
            transform: none

    .sd-ic
        grid-area: icon
        width: 48px
        height: 48px
        border-radius: 13px

    .sd-body
        grid-area: body

    .sd-right
        grid-area: cta
        width: 100%

    .sd-cta
        width: 100%
        padding: 12px 16px

        &:hover,
        .start-dh:hover &
            transform: none

    .sd-t
        font-size: 16px

    .sd-d
        font-size: 12px

    .sd-badge
        font-size: 9px
        padding: 3px 8px

    .sd-dot
        width: 14px
        height: 4px

    .sd-steps
        gap: 5px
        margin-top: 10px

    .sd-steps-l
        width: 100%
        margin-left: 0
        margin-top: 2px
        white-space: normal

    .sd-steps-loader
        flex: 1 1 100%
        max-width: none
</style>
